// Component Name:  Buttons Component
// Author: Lavanya S
// Platform:
// OS: Windows
// IDE: Visual Studio Code
// Reference: Original
// Date: 26-08-2024
// Description:  This component has a multiple named components, for all kind of buttons
// props: 1. name= name of the button,
// 2. handleClick= defines onClick  behaviour of the button
// Dependencies: React library,
// Interfaces: props
// Maintenance History: 1.0 First Version

// Integrated on 14-05-2025
import React, { useState } from "react";

// Active Button component:
export const ActiveBtn = ({ name, handleClick, image, hoverImg, customWidth }) => {
  const [isAdd, setIsAdd] = useState(false);
  const styles = {
    addBtn: {
      cursor: "pointer",
      borderRadius: "20px",
      height: "35px",
      width: customWidth ? customWidth : "174px",
      backgroundColor: isAdd ? "transparent" : "#005C8E",
      transition: "backgroundColor 0.9s ease-in-out",
      border: isAdd ? "2px solid #008CD7" : "none",
      color: isAdd ? "#008CD7" : "#FFFFFF",
      fontSize: "16px",
      margin: "0 10px",
      fontWeight: "700",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
    },
  };
  return (
    <button style={styles.addBtn} onMouseOver={() => setIsAdd(true)} onMouseLeave={() => setIsAdd(false)} onClick={handleClick}>
      {image && <img src={isAdd ? hoverImg : image} alt="btnImg" style={{ width: "20px", height: "20px" }} />}
      {name && <span className={`${image && "ml-2"}`}>{name}</span>}
    </button>
  );
};

// InActive Button component
export const InActiveBtn = ({ name, image, customWidth }) => {
  const styles = {
    inActiveBtn: {
      borderRadius: "20px",
      height: "35px",
      width: customWidth ? customWidth : "174px",
      backgroundColor: "#C1C1C1",
      transition: "backgroundColor 0.9s ease-in-out",
      border: "none",
      color: "#7E7E7E",
      fontSize: "16px",
      margin: "0 10px",
      fontWeight: "700",
      textAlign: "center",
      cursor: "not-allowed", 
    },
  };
  return (
    <button style={styles.inActiveBtn} disabled>
      {image && <img src={image} alt="btnImg" style={{ width: "20px", height: "20px" }} />}
      {name && <span className={`${image && "ml-2"}`}>{name}</span>}
    </button>
  );
};

// Cancel button component
export const CancelBtn = ({ name, handleClick, customWidth }) => {
  const [isCancel, setIsCancel] = useState(false);
  const styles = {
    cancelBtn: {
      cursor: "pointer",
      borderRadius: "20px",
      height: "35px",
      width: customWidth ? customWidth : "174px",
      backgroundColor: "#EFEFEF",
      transition: "backgroundColor 0.9s ease-in-out",
      border: isCancel ? "2px solid #008CD7" : "2px solid #C1C1C1",
      color: isCancel ? "#008CD7" : "#7E7E7E",
      fontSize: "16px",
      margin: "0 10px",
      fontWeight: isCancel ? "700" : "400",
      textAlign: "center",
    },
  };
  return (
    <button style={styles.cancelBtn} onMouseOver={() => setIsCancel(true)} onMouseLeave={() => setIsCancel(false)} onClick={handleClick}>
      {name}
    </button>
  );
};
